import '../../css/Main/Features.css'
import GLS from '../../Assets/gls.png'


const Features = () => {
  return (
    <div className='features-container'>
        <div className='features-item'>
            <h2>Gyors szállítás</h2>
            <img src={GLS} alt="" />
            <p>Webáruházunkban kiemelt figyelmet fordítunk arra, hogy a megrendeléseket a lehető legrövidebb időn belül kiszolgáljuk. Tudjuk, hogy vásárlóink számára fontos a gyors és megbízható kézbesítés, ezért minden rendelést azonnal feldolgozunk és a lehető leghamarabb útnak indítunk.

Szolgáltatásunk keretében országos kiszállítást biztosítunk megbízható futárszolgálatokon keresztül, így a csomagok jellemzően 1-2 munkanapon belül megérkeznek a megadott címre. A szállítási folyamatot nyomon követheted, így mindig pontosan tudni fogod, hol jár a csomagod és mikorra várhatod a kézbesítést.
</p>
        </div>
    </div>
  )
}

export default Features